import React from "react"

const HeaderOffset = ({activeOffset}) =>
(
  <section className={"header-offset "+activeOffset}>
  </section>
);

export default HeaderOffset;
